<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app >
        <router-view></router-view>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import PageHeader from '@/components/PageHeader';
import AppEvents from  './event';


export default {
  name: 'App',
  metaInfo: {
    title: 'PSM',
    titleTemplate: '%s | Pack Ship Manage'
  },
  components: {
    AppDrawer,
    AppToolbar,
    PageHeader
  },
  data () {
    return {
      //
    }
  },
  computed: {
    ...mapGetters("app", ["languageSelected"]),
  },
  created () { 
    
    //if (localStorage.LANG) {
    //  console.log("Storage App Vue : " + localStorage.getItem("lang"));
    //}

    let loadLang = localStorage.getItem("lang") ? localStorage.getItem("lang") : process.env.VUE_APP_DEFAULT_LANGUAGE
    loadLang = loadLang ? loadLang : this.languageSelected
    //console.log("Load Lang : " + loadLang);

    this.setLanguage(loadLang)
    this.$i18n.locale = loadLang;
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
  },
  methods: {
    ...mapActions("app", ["setLanguage"]),
  }
}
</script>
